/*
  eslint-disable
  import/no-dynamic-require,
  global-require,
  no-undef,
  consistent-return,
  react/jsx-filename-extension
*/
import React from 'react';

import LocationsContextWrapper from './src/components/LocationsContextWrapper';

export function wrapPage(
  { element, props },
  { defaultActiveLocationId, defaultToPrimary, useStorage },
) {
  return (
    <LocationsContextWrapper
      {...props}
      defaultActiveLocationId={defaultActiveLocationId}
      defaultToPrimary={defaultToPrimary}
      useStorage={useStorage}
    >
      {element}
    </LocationsContextWrapper>
  );
}
